import React from 'react';
import trans from 'translate';
import PropTypes from 'prop-types';
import BreadcrumbsPageTitle from '../Common/BreadcrumbsPageTitle/BreadcrumbsPageTitle';

import WalletIcon from '../Common/Icons/WalletIcon';
import './NotConnectedBlocker.scss';

const NotConnectedBlocker = ({ blockerPageTitle }) => {
  const isArr = Array.isArray(blockerPageTitle);

  return (
    <div className="not-connected-blocker-wrapper width-container">
      {isArr ? <BreadcrumbsPageTitle routes={blockerPageTitle} /> : <div className="title">{blockerPageTitle}</div>}

      <div className="icon-text-wrapper">
        <WalletIcon />

        <div className="text">{trans('errors.connect_wallet')}</div>
      </div>
    </div>
  );
};

NotConnectedBlocker.propTypes = {
  blockerPageTitle: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
};

export default NotConnectedBlocker;
